
import * as React from "react";
import { cn } from "@/lib/utils";

interface SidebarSimpleProps {
  className?: string;
  children: React.ReactNode;
}

export const SidebarSimple = React.forwardRef<
  HTMLDivElement,
  SidebarSimpleProps & React.HTMLAttributes<HTMLDivElement>
>(({ className, children, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        "flex h-full w-[--sidebar-width] flex-col bg-sidebar text-sidebar-foreground",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
});

SidebarSimple.displayName = "SidebarSimple";
